<!--专题讲座-->
<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <butn
        class="btn-wrapper"
        v-permission="'topicLectureLearn:import'"
        btntype="primary"
        title="导入理论中心组学习记录"
        @click="importShow()"
      ></butn>
      <div class="search_right">
        <Search class="search-wrapper" @search="searchHandle" :lectureTypes="lectureTypes" topicPlacehodler="请输入学习名称并选择" @changeTopic="changeTopic" />
      </div>
    </div>
    <TopicHeader :type="2" :info="currentTopicInfo"/>
    <!--表格内容栏-->
    <div class="topicLecture_table">
      <Tables :data="dataList" @onTrainInfo="onTrainInfo"/>
    </div>
    <!--分页栏-->
    <div class="RCPagination">
      <RCPagination ref="pagination" v-model="dataList" :api="api" :startRequest="false"/>
    </div>
    <ImportDia
      @closeImport="closeImport"
      :importInfo="importInfo"
      v-if="importInfo.show"
    />
    <TrainInfoDia ref="trainInfo" :type="2"/>
  </div>
</template>
<script>
import butn from "@/components/button/index";
import RCPagination from "@/components/pagination/paginationManage";
import ImportDia from "./import.vue";

import { getTopicLecturePageNew } from "@/api/topicLecture";
import Search from "@/pages/topicLecture/components/search.vue";
import Tables from "@/pages/topicLecture/components/table.js";
import TrainInfoDia from "@/pages/topicLecture/components/trainInfoDia.vue";
import TopicHeader from "@/pages/topicLecture/components/topicHeader.vue"

export default {
  name: "theoreticalStudyRecord",
  components: { butn, Tables, Search, RCPagination, ImportDia, TrainInfoDia, TopicHeader },
  data() {
    return {
      dataList: [{}],
      api: getTopicLecturePageNew,
      dataname: "",
      importInfo: {
        show: false,
        title: "",
        nowType: 0,
      },
      lectureTypes: [3],
      currentTopicInfo: {},
    };
  },
  created() {
    this.$nextTick(() => {
      this.searchHandle();
    })
  },
  methods: {
    //搜索
    searchHandle(data = {}) {
      this.dataname = {...data, lectureTypes: this.lectureTypes};
      if (!data.lectureId) {
        this.currentTopicInfo = {};
      }
      this.$refs["pagination"].search(this.dataname);
    },
    importShow() {
      this.importInfo = {
        show: true,
        title: "导入理论中心组学习记录"
      };
    },
    closeImport(flag) {
      this.importInfo.show = false;
      if (flag) {
        this.searchHandle();
      }
    },

    onTrainInfo(row) {
      this.$refs.trainInfo.show({
        userId: row.uuid,
        lectureTypes: this.lectureTypes
      });
    },

    changeTopic(item) {
      this.currentTopicInfo = item;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.topicLecture_table .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #FFFFFF;
}
</style>
